import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import ModalContent from "./Modal/AIQueryModal";
import { get_Ai_Query_Results } from "../../../services/AdminProgramApi";
import { Tooltip } from "antd";
import { makeStyles } from "@material-ui/styles";
import { useParams } from "react-router-dom";

const theme = localStorage.getItem("brandColor");

const StyledButton = styled.button`
  background: ${theme};
  width: 250px;
  border-radius: 20px;
  height: 35px;
  text-align: center;
  font-size: 18px;
  color: white;
  font-weight: 500;
  border: none;
  margin-top: 15px;
  padding: 5px 10px;
`;

const StyledForm = styled.form`
  display: flex;
  justify-content: center;
  //   margin-left: 20%;
  flex-direction: column;
`;

const StyledLabel = styled.label`
  flex: 1;
  margin-right: 10px;
  display: inline;
  width: 30%;
`;

const StyledFormInputDiv = styled.div`
  display: flex;

  margin-top: 4px;

  width: 100%;
`;

const FormDivStyle = {
  position: "relative",
  display: "inline",
  width: "100%",
  textAlign: "left",
};

const StyledButtonST = styled.button`
  background: ${theme};
  width: 80px;
  border-radius: 20px;
  height: 25px;
  text-align: center;
  font-size: 15px !important;
  color: white;
  font-weight: 400;
  border-color: none;
  border: none;
`;

const useStyles = makeStyles({
  root: {
    height: "400px",
    "& .super-app-theme--header": {
      // backgroundColor: "#ff8c24",
      // border: "1px solid #ff8c24",
      color: "#FFFFFF",
      fontWeight: "600",
    },
  },
});

const AI_Assistant_list = ({ match }) => {
  console.log("Ai_list");
  let queryCode;
  const customerid = useParams();
  const customerids = match.params.customerid;
  console.log("AILISTCID", customerids);
  const history = useHistory();
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(100);
  const [aiQueryResults, setAiQueryResults] = useState([]);
  const [templ_typeid, settempl_typeid] = useState("");
  const [td_code, settd_code] = useState("");
  const [has_custom_topics, set_has_custom_topics] = useState(0);
  const [alert_modal, set_alert_modal] = useState(false);
  const [edit_custom_topic_data_modal, setEdit_custom_topic_data_modal] =
    useState(false);
  const [formErrors, setFormErrors] = useState([]);
  useEffect(() => {
    //receiveCustomTopicData();
    getAiQueryResultParameters(customerid);
  }, []);

  const getAiQueryResultParameters = async (customerid) => {
    try {
      console.log("cs", customerid);
      const res = await get_Ai_Query_Results(customerid);
      if (res.data.code === 200) {
        setAiQueryResults(res.data.results);
        set_has_custom_topics(res.data.custom_topics);
        //console.log(res.data.results);
        console.log("status : ", "success");
      } else {
        console.log("status : ", "failure");
      }
    } catch {
      console.log("Api failed");
    }
  };

  //   const receiveCustomTopicData = async () => {
  //     try {
  //       const res = await get_ai_templates_data({ customerid });

  //       if (res.data.code === 200) {
  //         setCustomTopicData(res.data.template_details);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching custom topic data:", error);
  //       // Handle error (e.g., show a message)
  //     }
  //   };

  const StartButton = ({ data }) => {
    const handleStartClick = () => {
      const { Query_Code } = data;
      console.log("querycode", Query_Code);
      history.push("/adminfunction/ai_result/" + Query_Code);
      // setEdit_custom_topic_data_modal(true)
      // settempl_typeid(data.templ_typeid)
      // settd_code(data.td_code)
      console.log(data);
    };

    return (
      <StyledButtonST onClick={handleStartClick} style={{ width: 100 }}>
        Select
      </StyledButtonST>
    );
  };

  // const ConvertButton = ({ data  }) => {
  //   const handleStartClick = () => {
  //     const {Query_Code }  = data;
  //     console.log("querycode",Query_Code);
  //      //history.push("/adminfunction/AI_Assistant_Question_Results_list/"+Query_Code);
  //     // setEdit_custom_topic_data_modal(true)
  //     // settempl_typeid(data.templ_typeid)
  //     // settd_code(data.td_code)
  //     console.log(data)
  //   };

  //   return (
  //     <StyledButtonST onClick={handleStartClick} style={{ width: 100 }}>
  //       Convert
  //     </StyledButtonST>
  //   );
  // };

  const ConvertButton = ({ data }) => {
    const handleStartClick = () => {
      const { Query_Code } = data;
      if (has_custom_topics == 0) {
        set_alert_modal(true);
      } else {
        history.push("/adminfunction/available_custom_topics/" + Query_Code);
      }
    };

    return (
      <StyledButtonST onClick={handleStartClick} style={{ width: 100 }}>
        Convert
      </StyledButtonST>
    );
  };

  // ------- Reset Fields Function --------
  const resetFields = () => {
    setFormErrors([]);
  };

  const columnsUsers = [
    {
      field: "TD_Name",
      headerName: "Template",
      flex: 0.3,
      align: "left",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Tooltip title={params.value}>
          {params.value?.length > 60
            ? `${params.value.substring(0, 60)}...`
            : params.value}
        </Tooltip>
      ),
    },
    {
      field: "parm_queries",
      headerName: "Parameters",
      flex: 0.3,
      align: "left",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Tooltip title={params.value}>
          {params.value?.length > 200
            ? `${params.value.substring(0, 200)}...`
            : params.value}
        </Tooltip>
      ),
    },
    {
      field: "Query_Date",
      headerName: "Query Date",
      type: "text",
      flex: 0.1,
      align: "center",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        // <input
        //   name="check[1]"
        //   type="radio"
        //   className="form-check-input"
        // />
        <Tooltip title={params.value}>
          {params.value?.length > 200
            ? `${params.value.substring(0, 200)}...`
            : params.value}
        </Tooltip>
      ),
    },
    {
      field: "Action1",
      headerName: "Select",
      type: "text",
      flex: 0.1,
      align: "center",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        // <input
        //   name="check[1]"
        //   type="radio"
        //   className="form-check-input"
        // />
        <div>
          <StartButton data={params.row} />
        </div>
      ),
    },
    {
      field: "Action2",
      headerName: "Convert",
      type: "text",
      flex: 0.1,
      align: "center",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        // <input
        //   name="check[1]"
        //   type="radio"
        //   className="form-check-input"
        // />
        <div>
          <Tooltip
            title="Convert this query to a custom topic. First create a Custom Topic using the ‘Add Custom Topic’ button in the Custom Topic Admin menu. The topic status must equal ‘New’."
            arrow
          >
            <div>
              <ConvertButton data={params.row} />
            </div>
          </Tooltip>
        </div>
      ),
    },
    // {
    //   headerName: "Select",
    //   flex: 0.1,
    //   align: "center",
    //   headerAlign: "center",
    //   headerClassName: "super-app-theme--header",
    // },
    // {
    //   headerName: "Convert",
    //   flex: 0.1,
    //   align: "center",
    //   headerAlign: "center",
    //   headerClassName: "super-app-theme--header",
    // },
  ];
  console.log(columnsUsers);
  const rows = aiQueryResults.map((data, index) => ({
    ...data,
    id: index + 1,
    SNo: index + 1,
  }));

  const closeModal = () => {
    setEdit_custom_topic_data_modal(false);
    set_alert_modal(false);
  };

  return (
    <div className="container-fluid">
      <ReactModal
        className="ModalStyle1 Width90"
        isOpen={alert_modal}
        onRequestClose={closeModal}
      >
        <div className="text-end">
          <a onClick={closeModal}>
            <i className="fas fa-times-circle fa-lg" aria-hidden="true"></i>
          </a>
        </div>
        <div align="center">
          <h5>No valid custom topics found</h5>
          <p>First create an empty Custom Topic with a Status='New'.</p>
          <StyledButton
            style={{ marginTop: 20 }}
            onClick={() => {
              history.push(`/adminfunction/custom_topic_data/${customerids}`);
            }}
          >
            Go to Custom Topic
          </StyledButton>
        </div>
      </ReactModal>
      <div className="mt-4 row text-center" align="center">
        <div className=" d-flex justify-content-around" align="center">
          <StyledButton
            onClick={() => {
              history.push(`/adminfunction/ai_assistant/${customerids}`);
            }}
          >
            Return to AI Assistant
          </StyledButton>
        </div>

        <div>
          {/* --------------- Edit Modal ------------ */}
          {edit_custom_topic_data_modal && (
            <ModalContent
              closeModal={closeModal}
              initialValues={{
                customerid: customerid,
                userid: localStorage.getItem("UserID"),
                templ_typeid: templ_typeid,
                td_code: td_code,
              }}

              // onSubmitSuccess={handleSubmitSuccess}
            />
          )}
        </div>

        <div
          className={classes.root}
          style={{
            height: "78vh",
            width: "100%",
            marginTop: 30,
            overflow: "hidden",
          }}
        >
          <DataGrid
            sx={{
              ".MuiDataGrid-columnHeaders": {
                backgroundColor: theme,
              },
              "&.MuiDataGrid-root": {
                border: "none",
              },
            }}
            rows={rows}
            columns={columnsUsers}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[100]}
            pagination
            hideFooterPagination={rows.length <= pageSize}
          />
        </div>
      </div>
    </div>
  );
};

export default AI_Assistant_list;
